import Pie2DDataset from './pie2d';
import { addDep } from '../dependency-manager';
import { hasSVG, pluckNumber, pluck } from '../lib/lib';
import doughnut2dAnimation from '../animation-rules/doughnut2d-animation';
let COMMASTRING = ',',
  _getInnerSize = function () {
    var innerradius,
      dataSet = this,
      chart = dataSet.getFromEnv('chart'),
      dataSetConfig = dataSet.config,
      chartAttr = chart.getFromEnv('dataSource').chart,
      doughnutRadius = dataSetConfig.doughnutradius,
      use3DLighting = pluckNumber(chartAttr.use3dlighting, 1),
      radius3D = use3DLighting ? pluckNumber(chartAttr.radius3d, chartAttr['3dradius'], 50) : 100,
      innerpercentR,
      diff50Percent,
      radius3Dpercent,
      pointConfig,
      poin2nd,
      ratioStr,
      x,
      point,
      data,
      length,
      pieMinRadius = dataSetConfig.pieMinRadius;
    if (radius3D > 100) {
      radius3D = 100;
    }
    if (radius3D < 0) {
      radius3D = 0;
    }
    /*
     * Decide inner radius
     */
    if (/%/.test(doughnutRadius)) {
      doughnutRadius = Number(doughnutRadius.split('%')[0]) / 100;
      innerradius = pieMinRadius * doughnutRadius;
    } else if (doughnutRadius <= 0 || doughnutRadius >= pieMinRadius) {
      innerradius = pieMinRadius / 2;
    } else {
      innerradius = pluckNumber(doughnutRadius);
    }

    dataSetConfig.innerRadius = innerradius;
    // hcJSON.plotOptions.pie3d.innerSize = hcJSON.plotOptions.pie.innerSize = 2 * innerradius;

    /*
      * Create doughnut type 3d lighting
      */
    if (radius3D > 0 && hasSVG) { // Radial gradient is not supported in VML
      innerpercentR = parseInt(innerradius / pieMinRadius * 100, 10);
      diff50Percent = (100 - innerpercentR) / 2;
      radius3Dpercent = parseInt(diff50Percent * radius3D / 100, 10);
      poin2nd = 2 * (diff50Percent - radius3Dpercent);
      ratioStr = innerpercentR + COMMASTRING + radius3Dpercent + COMMASTRING + poin2nd + COMMASTRING +
                    radius3Dpercent;
      // Loop for all points
      if (dataSet && (data = dataSet.components.data)) {
        for (x = 0, length = data.length; x < length; x += 1) {
          point = data[x];
          pointConfig = point.config;
          if (pointConfig.color) {
            pointConfig.color.ratio = ratioStr;
            if (pointConfig.hoverEffects && pointConfig.hoverEffects.color) {
              pointConfig.hoverEffects.color.ratio = ratioStr;
            }
          }
        }
      }
    }
    return innerradius * 2;
  };
addDep({
  name: 'doughnut2dAnimation',
  type: 'animationRule',
  extension: doughnut2dAnimation
});
class Doughnut2DDataset extends Pie2DDataset {
  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'dataset';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'doughnut2D';
  }
  configureAttributes (dataObj) {
    super.configureAttributes(dataObj);
    let dataset = this,
      conf = dataset.config,
      chartConfig = dataset.getFromEnv('chartConfig');
    conf.doughnutradius = pluck(chartConfig.doughnutradius, conf.doughnutradius, '50%');
  }
  __setDefaultConfig () {
    super.__setDefaultConfig();
    this.config.doughnutradius = '50%';
  }
  _parsePiePlotOptions () {
    var dataSet = this,
      piePlotOptions = super._parsePiePlotOptions();

    piePlotOptions.innerSize = dataSet._getInnerSize();
    return piePlotOptions;
  }
  _getInnerSize () {
    return _getInnerSize.call(this);
  }

  allocatePosition () {
    this.config.innerSize = this._getInnerSize();
    super.allocatePosition();
  }
}
export { _getInnerSize };
export default Doughnut2DDataset;
